import {
  isServiceHistoryMakeAndYearEligible,
  SERVICE_HISTORY_MAKES,
} from "../../lib/service-history-eligibility.js";
import { yearFrom } from "../../lib/vehicle/year.js";

const API_BASE = import.meta.env?.VITE_VEHICLE_API_BASE || "/vehicle-api";

export { SERVICE_HISTORY_MAKES };

async function fetchJson(url) {
  const response = await fetch(url, { headers: { Accept: "application/json" } });
  if (!response.ok) {
    const error = new Error(`Vehicle data request failed with ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export function isServiceHistoryEligible(vehicle) {
  return isServiceHistoryMakeAndYearEligible(vehicle?.make, vehicle?.year);
}

export function normalizeVehicleData(mot = {}, dvla = {}, fallbackRegistration = "") {
  if (Array.isArray(mot)) mot = mot[0] || {};
  const vehicle = {
    registration: mot.registration || dvla.registrationNumber || dvla.reg || fallbackRegistration,
    make: mot.make || dvla.make || null,
    model: mot.model || null,
    year: Number(dvla.yearOfManufacture) || yearFrom(mot.manufactureDate, mot.registrationDate, mot.firstUsedDate, dvla.monthOfFirstRegistration),
    firstUsedDate: mot.firstUsedDate || mot.registrationDate || dvla.monthOfFirstRegistration || null,
    fuelType: mot.fuelType || dvla.fuelType || null,
    colour: mot.primaryColour || dvla.colour || null,
    engineSize: mot.engineSize || dvla.engineCapacity || null,
    taxStatus: dvla.taxStatus || null,
    taxDueDate: dvla.taxDueDate || null,
    v5cIssuedDate: dvla.dateOfLastV5CIssued || null,
    motTests: Array.isArray(mot.motTests) ? mot.motTests : [],
  };

  return {
    ...vehicle,
    serviceHistoryEligible: isServiceHistoryEligible(vehicle),
  };
}

export async function getVehicle(registration) {
  const reg = registration.toUpperCase().replace(/[^A-Z0-9]/g, "");
  const [motResult, dvlaResult, availabilityResult] = await Promise.allSettled([
    fetchJson(`${API_BASE}/mot?reg=${encodeURIComponent(reg)}`),
    fetchJson(`${API_BASE}/dvla?reg=${encodeURIComponent(reg)}`),
    fetchJson(`/api/service-history-availability?reg=${encodeURIComponent(reg)}`),
  ]);

  if (motResult.status === "rejected" && dvlaResult.status === "rejected") {
    const error = new Error("Vehicle details could not be loaded.");
    error.notFound = motResult.reason?.status === 404 && dvlaResult.reason?.status === 404;
    throw error;
  }

  const mot = motResult.status === "fulfilled" ? motResult.value : {};
  const dvla = dvlaResult.status === "fulfilled" ? dvlaResult.value : {};
  const vehicle = normalizeVehicleData(mot, dvla, reg);
  return {
    ...vehicle,
    serviceHistoryKnownEmpty: availabilityResult.status === "fulfilled" && availabilityResult.value?.known_empty === true,
  };
}
